export default __webpack_public_path__ + "static/media/icons-right.a5578fe0.png";